import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
// import Markdown from './markdown.md';
import App from './App';
import ConverterMain from './page/tool/ConverterMain';
import RootStore from './store/RootStore';
import context from './context';
import '../src/api/AxiosInterceptors';
// mobx-react连接库,内置组件
import { Provider } from 'mobx-react';
import axios from 'axios';

// 初始化逻辑
async function getConfig() {
    // 执行初始化操作，例如设置全局配置、初始化状态等
    // 例如，可以加载一些初始数据，设置全局变量等
    const rootUrl = context.homePage();
    await axios.get("appConfig.json",{baseURL: rootUrl}).then(res=>{
        context.appConfig = res;
    }).catch(e=>{
        console.log(e);
    })
}

// 使用立即调用的异步函数（IIFE）
(async () => {
    await getConfig();
    createRoot(document.getElementById('app_root')).render(
        <Provider {...new RootStore()}>
            <ConverterMain />
            {/* <div>{Markdown}</div> */}
        </Provider>
    );
  })();